import { Box } from '@spark-web/box';
import { HomeIcon } from '@spark-web/icon';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

type InstallationAddressCardProps = {
  address?: string;
};

// Shared so the confirm-address screen and the title-check failed state show the same
// card — they had drifted into two sizes of the same thing.
function InstallationAddressCard({ address }: InstallationAddressCardProps) {
  return (
    <Box
      display="flex"
      alignItems="start"
      gap="medium"
      paddingX="large"
      paddingY="xlarge"
      borderRadius="medium"
      background="surfaceMuted"
      borderWidth="standard"
      border="standard"
    >
      <Box flexShrink={0} paddingTop="xsmall">
        <HomeIcon size="small" tone="primary" />
      </Box>
      <Stack gap="large">
        <Text size="xsmall" weight="semibold" transform="uppercase">
          Installation address
        </Text>
        {address ? (
          <Text size="xlarge">{address}</Text>
        ) : (
          <Text size="xlarge" tone="muted">
            Address not available
          </Text>
        )}
      </Stack>
    </Box>
  );
}

export default InstallationAddressCard;
